import { render, staticRenderFns } from "./Hospital.vue?vue&type=template&id=0e1f9d98"
import script from "./Hospital.vue?vue&type=script&lang=js"
export * from "./Hospital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports